var $7a9b12305dc281e7$exports = {};
$7a9b12305dc281e7$exports = {
    "help": `Hj\xe4lp`,
    "info": `Information`
};


export {$7a9b12305dc281e7$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
